import React from 'react';

/** Section generated from the "BlogArticlePage" block of the Aurm design handoff. */
export default function BlogArticlePage({ V }) {
  return (<>
    <article>{" "}
      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "88px 40px 48px" }}>{" "}
        <a className="aurm-he" href="/blogs" style={{ display: "inline-flex", alignItems: "center", gap: "8px", fontSize: "14px", fontWeight: "500", color: "rgba(255,255,255,.72)" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M15 6l-6 6 6 6"></path>
          </svg>All articles
        </a>{" "}
        <h1 style={{ marginTop: "32px", fontSize: "clamp(34px,4.6vw,60px)", lineHeight: "1.05", letterSpacing: "-.035em", fontWeight: "600" }}>{V.post.title}</h1>{" "}
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "32px" }}>
          <img src={V.post.avatar} alt="" style={{ width: "44px", height: "44px", borderRadius: "50%", objectFit: "cover", background: "#2a1c46" }} />
          <span style={{ fontSize: "14px", lineHeight: "1.4" }}>
            <span style={{ display: "block", fontWeight: "600" }}>{V.post.by}</span>
            <span style={{ color: "rgba(255,255,255,.6)" }}>{"Published "}{V.post.at}</span>
          </span>
        </div>{" "}
      </div>{" "}
      <div data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 40px" }}>
        <div style={V.post.hero}></div>
      </div>{" "}
      <div style={{ maxWidth: "720px", margin: "0 auto", padding: "72px 40px 0", display: "flex", flexDirection: "column", gap: "24px" }}>{" "}
        {(V.post.blocks || []).map((bk, $index) => (
          <React.Fragment key={$index}>{" "}
          {bk.isP ? (<>
            <p style={{ fontSize: "18px", lineHeight: "1.75", color: "rgba(255,255,255,.84)" }}>{bk.text}</p>
          </>) : null}{" "}
          {bk.isQ ? (<>
            <blockquote style={{ margin: "24px 0", padding: "8px 0 8px 28px", borderLeft: "2px solid #DB2349", fontSize: "clamp(22px,2.4vw,30px)", lineHeight: "1.3", letterSpacing: "-.02em", fontWeight: "500" }}>{bk.text}</blockquote>
          </>) : null}{" "}
          </React.Fragment>
        ))}{" "}
      </div>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "128px 40px 0" }}>{" "}
        <h2 style={{ fontSize: "28px", letterSpacing: "-.02em", fontWeight: "600" }}>More from the blog</h2>{" "}
        <div style={{ marginTop: "28px", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,340px),1fr))", gap: "20px" }}>{" "}
          {(V.morePosts || []).map((b, $index) => (
            <React.Fragment key={$index}>{" "}
            <a className="aurm-h6" href={b.href} style={{ display: "grid", gridTemplateColumns: "140px 1fr", gap: "20px", alignItems: "center", padding: "14px", borderRadius: "22px", border: "1px solid rgba(255,255,255,.12)", background: "linear-gradient(180deg,rgba(46,30,78,.97),rgba(34,20,60,.97))" }}>{" "}
              <div style={b.thumb}></div>{" "}
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", minWidth: "0" }}>
                <h3 style={{ fontSize: "17px", lineHeight: "1.3", fontWeight: "600" }}>{b.title}</h3>
                <p style={{ fontSize: "13px", color: "rgba(255,255,255,.6)" }}>{b.by}{" - "}{b.at}</p>
              </div>{" "}
            </a>{" "}
            </React.Fragment>
          ))}{" "}
        </div>{" "}
      </section>
    </article>
  </>);
}
